// Tile index map for tiny16_basictiles.png (8 cols x 15 rows of 16x16 tiles).
// Indices are row * 8 + col. Verified visually from scripts/_tile_preview/basictiles_grid.png.
export const T = {
  // --- Walls (top of buildings) ---
  wallStoneTopL: 0, wallStoneTopM: 1, wallStoneTopR: 2, wallStoneTopRR: 3,
  wallBrickTopL: 4, wallBrickTopM: 5, wallBrickTopR: 6, wallBrickTopRR: 7,

  // --- Floors / ground bases ---
  floorWoodPlanks: 8,
  floorRedSquare: 9,
  grassYellow: 10,
  grassGreen: 11,
  grassFlowers: 12,
  pathCobble: 13,    // blue-stone cobblestone path
  pathDirt: 14,      // brown dirt
  leavesAutumn: 15,

  // --- Patches / accents ---
  fenceWood: 16,
  runeRed: 17,
  patchYellow: 18,
  bushGreen: 19,
  fernGreen: 20,
  water: 21,
  voidBlack: 22,
  rockOrange: 23,

  // --- Arena rope (yellow) corners ---
  ropeTL: 24, ropeT: 25, ropeTR: 26,
  pot: 27, golden: 28, sparkleN: 29, treeSmall: 30, barrel: 31,

  // --- Arena rope sides ---
  ropeL: 32, ropeC: 33, ropeR: 34,
  chestClosed: 35, chestOpen: 36, sparkleS: 37, treeMedium: 38, barrelStone: 39,

  // --- Arena rope bottom + fountain frags ---
  ropeBL: 40, ropeB: 41, ropeBR: 42,
  fountainTop: 43, sparklePath: 44, bedSm: 45, bedTop: 46, anvilStone: 47,

  // --- Doors / wooden gate ---
  doorWoodClosed: 48, doorWoodGate: 49, doorWoodDark: 50, candleLit: 51,
  bedFurMid: 52, bedHorz: 53, dresser: 54, drawer: 55,

  // --- Wall/rock edges ---
  rockEdgeL: 56, rockEdgeR: 57, rockPile: 58, signPostL: 59,
  fireSmall: 60, torchLit: 61, tent: 62, snowMountain: 63,

  // --- Ground patch decals ---
  grassPatchL: 64, grassPatchR: 65, dirtPatch: 66, anvil: 67, goldPile: 68,
  cookpot: 69, banner: 70, banner2: 71,

  // --- Wood floors (interior) ---
  woodFloorH: 72, woodFloorV: 73, brickPathRed: 74, brickPathYel: 75,
  treeSm: 76, treeYg: 77, banner3: 78, banner4: 79,

  // --- Wood plank wall ---
  plankH: 80, plankV: 81,
  // 82-87 empty
  plankCloseDoorL: 88, plankCloseDoorR: 89, plankRoofL: 90,
  pillarBroken: 91, treeMedSm: 92,
  // 93-95 empty

  // --- Pillar/Cage/etc. ---
  pillarFull: 99,
  cageTL: 102, cageTR: 103,
  cageBL: 110, cageBR: 111,

  treeBig: 116,
} as const;

// Tile indices for tiny16_things.png (12 cols x 8 rows of 16x16).
export const TH = {
  // Wooden barrels & planks
  barrelTopWood: 0, barrelMidWood: 1, barrelBotWood: 2,
  barrelTopGray: 3, barrelMidGray: 4, barrelBotGray: 5,
  // Chests closed / open
  chestS: 6, chestSOpen: 7, chestSGold: 8,
  potS: 9, potM: 10, potL: 11,
  barrelTopWood2: 12, barrelMidWood2: 13, barrelBotWood2: 14,
  barrelTopMetal: 15, barrelMidMetal: 16, barrelBotMetal: 17,
  chestM: 18, chestMOpen: 19, chestMGold: 20,
  potBowl: 21, potBowlOpen: 22, potBig: 23,
  // Big chests / fancy
  chestL: 30, chestLOpen: 31, chestLGold: 32,
  pumpkin: 33, mushroom: 34, mushroomLit: 35,
  rockPathL: 42, rockPathM: 43, rockPathR: 44,
  // Torches (rows 4-7 = 48..)
  torchOrange: 48, torchOrangeLit: 49, torchOrangeBig: 50,
  torchBlue: 60, torchBlueLit: 61, torchBlueBig: 62,
  torchPurple: 72, torchPurpleLit: 73, torchPurpleBig: 74,
  torchGreen: 84, torchGreenLit: 85, torchGreenBig: 86,
  // Fireplaces
  fireplace1: 57, fireplace2: 58, fireplace3: 59,
  fireplace4: 69, fireplace5: 70, fireplace6: 71,
} as const;
